	 <h3 class="ui primary header" >Select {{ title }}
	<i class="link times icon" (click)="modal.deny(undefined)"></i>
	</h3>
 <div class="content" >
         <div *ngIf="screen == 'Lot'">
		<div class="ui small icon fluid input" style="margin: 5px;">
                        <input type="text" placeholder="Search lot..."   [formControl]="search" />
                        <i class="search icon"></i>
                  </div>
            </div>
       <div *ngIf="screen == 'Bidders'">
		<div class="ui small icon fluid input" style="margin: 5px;">
                        <input type="text" placeholder="Search for RC Number"   [formControl]="search" />
                        <i class="search icon"></i>
                  </div>
            </div>
       <div class="scroll-wrapper ui basic segment" [ngClass]="{'loading':pending}">
      <div *ngIf="success || error" tamsyMargin marginY="10px">
        <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
        <esl-message-toast [(message)]="error"></esl-message-toast>
      </div>
      <div *ngIf="screen == 'Form'"  class="ui form">
            <div class="field">
                  <label>Award Date</label>
                  <input type="text" placeholder="DD/MM/YY"/>
            </div>
             <div class="field">
                  <label>Amount</label>
                  <input type="text" placeholder="Select Lot Category"/>
            </div>
      </div>
            <div *ngIf="screen == 'Lot'" >
            <div class="ui segment side-panel link" *ngFor="let document of lots" appMargin marginB="10">
                  <div fxLayout="row" fxLayoutAlign='space-between center'>
                        <div fxFlex="grow">
                              <h3 class="ui primary header">{{document?.name}}</h3>
                              <div class="sub-item">Lot ID <label class="ui circular grey label">{{document?.id}}</label>  &nbsp; &nbsp;  &nbsp; &nbsp; Amount <label class="ui circular grey label">{{document?.amount}}</label></div>
                        </div>
                  </div>
            </div>
            </div>
      <div  *ngIf="screen == 'Tender'">
      <div class="ui segment side-panel link" *ngFor="let document of tenders" appMargin marginB="10">
            <div fxLayout="row" fxLayoutAlign='space-between center'>
                  <div fxFlex="grow">
                        <h3 class="ui primary header">{{document?.name}}</h3>
                        <div class="sub-item">Bidders <label class="ui circular grey label">{{document?.id}}</label>  &nbsp; &nbsp;  &nbsp; &nbsp; Creation On <label class="ui circular grey label">{{document?.createdOn}}</label></div>
                  </div>
            </div>
      </div>
      </div>

            <div  *ngIf="screen == 'Bidders'">
                  <div class="ui segment side-panel link" *ngFor="let document of bidders" appMargin marginB="10">
                        <div fxLayout="row" fxLayoutAlign='space-between center'>
                              <div fxFlex="grow">
                                    <h3 class="ui primary header">{{document?.name}}</h3>
                                    <div class="sub-item">RC Number <label class="ui circular grey label">{{document?.bidders}}</label>  &nbsp; &nbsp;  &nbsp; &nbsp; Creation On <label class="ui circular grey label">{{document?.createdOn}}</label></div>
                              </div>
                        </div>
                  </div>
                  </div>

       </div>
 </div>
      <div  class="actions">
    <button class="ui  basic primary button" (click)="modal.deny(undefined)">Cancel</button>
     <button class="ui  primary button" [ngClass]="{'yellow':pending}" [disabled]="pending" *ngIf="screen == 'Lot'" (click)="next('Tender')" autofocus>Next </button>
      <button class="ui  primary button" [ngClass]="{'yellow':pending}" [disabled]="pending" *ngIf="screen == 'Tender'" (click)="next('Bidders')" autofocus>Next </button>
      <button class="ui  primary button" [ngClass]="{'yellow':pending}" [disabled]="pending" *ngIf="screen == 'Bidders'" (click)="next('Form')" autofocus>Next </button>
      <button class="ui  primary button" [ngClass]="{'yellow':pending}" [disabled]="pending" *ngIf="screen == 'Form'" (click)="save()" autofocus>Create Award </button>

      </div>


